import { render, staticRenderFns } from "./ModifyMerchantInfo.vue?vue&type=template&id=3c806af5&scoped=true"
import script from "./ModifyMerchantInfo.vue?vue&type=script&lang=js"
export * from "./ModifyMerchantInfo.vue?vue&type=script&lang=js"
import style0 from "./ModifyMerchantInfo.vue?vue&type=style&index=0&id=3c806af5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c806af5",
  null
  
)

export default component.exports